import React, { useEffect, useState, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import "leaflet-canvas-marker/dist/leaflet.canvas-markers.js";
import { Divider, Spin } from "antd";
import { Link } from "react-router-dom";
import { URL_BASE } from "../../config/url-server";




///NO LO ESTOY USANDO PORQUE TRAE TODAS LAS PALMAS DE LA FINCA

const MapFarmPalms = () => {
    const [centerMap, setCenterMap] = useState([10.5582770671, -74.1915922693]);
    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token");
    const farmId = localStorage.getItem("farmId");
    const farmName = localStorage.getItem("farmName");
    const [mapData, setMapData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [existingPolygon, setExistingPolygon] = useState(null);

    const [capturingPoints, setCapturingPoints] = useState(false);
    const [manualPoints, setManualPoints] = useState([]);
    const [polygonLayer, setPolygonLayer] = useState(null);
    const [existingPolygonLayer, setExistingPolygonLayer] = useState(null);

    const mapRef = useRef(null);
    const canvasLayerRef = useRef(null);

    // Activar/desactivar modo captura
    const toggleCaptureMode = () => {
        if (capturingPoints) {
            // Cancelar captura
            setCapturingPoints(false);
            setManualPoints([]);
            if (polygonLayer) {
                polygonLayer.remove();
                setPolygonLayer(null);
            }
        } else {
            setCapturingPoints(true);
            setManualPoints([]);
            if (polygonLayer) {
                polygonLayer.remove();
                setPolygonLayer(null);
            }
        }
    };

    // Función para dibujar el polígono temporal

    const drawTempPolygon = (points, map) => {
        if (polygonLayer) {
            polygonLayer.remove();
        }

        if (points.length >= 2) {
            const polygon = L.polyline(points, {
                color: '#00ccff',
                weight: 5,
                opacity: 1,
                dashArray: "8, 8",
                interactive: false,
                bubblingMouseEvents: false
            }).addTo(map);

            setPolygonLayer(polygon);
        }
    };

    // Función para manejar el click en el mapa
    const handleMapClick = (e, map) => {
        if (!capturingPoints) return;

        const { lat, lng } = e.latlng;
        const newPoint = [lat, lng];

        setManualPoints(prev => {
            const updatedPoints = [...prev, newPoint];

            // Dibujar polígono temporal si tenemos suficientes puntos
            if (updatedPoints.length >= 2) {
                drawTempPolygon(updatedPoints, map);
            }

            return updatedPoints;
        });

        // Añadir marcador visual del punto
        const marker = L.circleMarker([lat, lng], {
            radius: 6,
            color: '#0077ff',
            weight: 2,
            fillColor: '#a3e6b9',
            fillOpacity: 5,
            interactive: true,
            bubblingMouseEvents: true
        }).addTo(map);

        marker.bindPopup(`Punto ${manualPoints.length + 1}<br/>Lat: ${lat}<br/>Lng: ${lng}`);

        // Guardar referencia para eliminarlo después si es necesario
        setTimeout(() => {
            if (!capturingPoints) {
                marker.remove();
            }
        }, 30000);
    };

    // Función para finalizar y guardar el polígono
    const finishPolygon = async () => {
        if (manualPoints.length < 3) {
            alert("Necesitas al menos 3 puntos para crear un polígono");
            return;
        }
        // Cerrar el polígono (añadir el primer punto al final)
        const closedPoints = [...manualPoints, manualPoints[0]];
        // Convertir a formato GeoJSON [lng, lat]
        const geoJsonCoordinates = closedPoints.map(point => [point[1], point[0]]);
        setManualPoints(geoJsonCoordinates)
        setCapturingPoints(false);
    };


    const saveFarmPolygon = async () => {
        if (manualPoints.length < 3) {
            alert("Necesitas al menos 3 puntos para crear un polígono");
            return;
        }
        // Cerrar el polígono (añadir el primer punto al final)
        const closedPoints = [...manualPoints, manualPoints[0]];
        // Convertir a formato GeoJSON [lng, lat]
        const geoJsonCoordinates = closedPoints.map(point => [point[1], point[0]]);
        setManualPoints(geoJsonCoordinates)
        setCapturingPoints(false);
        const polygonData = {
            polygon: {
                type: "Polygon",
                coordinates: [geoJsonCoordinates]
            },
            farmId: farmId
        };
        try {
            const config = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`
                }
            };
            const response = await axios.post(URL_BASE + "farm/update-polygon", polygonData, config);
            if (response.data.success) {
                alert("Polígono guardado exitosamente");
                // Colorear el polígono final en verde (guardado)
                if (polygonLayer) {
                    polygonLayer.setStyle({
                        color: '#4caf50',
                        fillOpacity: 0,
                        dashArray: null,
                        interactive: false, // Mantener no interactivo
                        bubblingMouseEvents: false
                    });
                }
                // Recargar el polígono existente
                if (existingPolygonLayer) {
                    existingPolygonLayer.remove();
                }
                setExistingPolygon(polygonData.polygon);
                drawExistingPolygon(mapRef.current, polygonData.polygon);
            }
            setManualPoints([]);
        } catch (error) {
            console.error("Error guardando polígono:", error);
            alert("Error al guardar el polígono: " + (error.response?.data?.message || error.message));
        }
    };




    // Función para dibujar el polígono existente en el mapa
    const drawExistingPolygon = (map, polygon) => {
        if (!map || !polygon || !polygon.coordinates || !polygon.coordinates[0]) return null;

        try {
            // Eliminar polígono existente si lo hay
            if (existingPolygonLayer) {
                existingPolygonLayer.remove();
            }

            // Convertir coordenadas de [lng, lat] a [lat, lng] para Leaflet
            const latLngPoints = polygon.coordinates[0].map(coord => [coord[1], coord[0]]);

            // Crear el polígono
            const polygonLayerNew = L.polygon(latLngPoints, {
                color: "#59f13b",
                weight: 5,
                opacity: 0.8,
                fillColor: "#59f13b",
                fillOpacity: 0,
                dashArray: "8, 8",
                className: 'existing-polygon',
                interactive: false, // IMPORTANTE: No bloquear clics en las palmas
                bubblingMouseEvents: false // No capturar eventos del mouse
            }).addTo(map);

            // Añadir popup con información (se mostrará al hacer clic en el borde)
            // Usamos bindTooltip en lugar de bindPopup para no interferir
            polygonLayerNew.bindTooltip('Límite de la Finca', {
                sticky: true,
                direction: 'center'
            });

            setExistingPolygonLayer(polygonLayerNew);

            // No ajustamos el mapa automáticamente para no interferir con la experiencia
            // del usuario que quiere ver las palmas

            return polygonLayerNew;
        } catch (error) {
            console.error("Error dibujando polígono existente:", error);
            return null;
        }
    };




    // ------------ CARGA DE LOTES + PALMAS + POLÍGONO -------------------
    const loadLotPositions = async () => {
        setLoading(true);
        try {
            const params = { farmId };
            const config = {
                headers: { client: clientId, Authorization: `Bearer ${accessToken}` },
                params,
            };

            const response = await axios.get(URL_BASE + "map/map-farm", config);
            const lots = response.data.data;
            const polygon = response.data.polygon;

            console.log("Polígono recibido:", polygon);

            // Validar si el polígono existe y no está vacío
            const hasValidPolygon = polygon &&
                polygon.coordinates &&
                polygon.coordinates[0] &&
                polygon.coordinates[0].length > 0;

            if (hasValidPolygon) {
                setExistingPolygon(polygon);
            } else {
                setExistingPolygon(null);
            }

            // Generar colores por lote
            const lotColors = generateLotColors(lots);

            setMapData({ lots, lotColors });

            // Centrar el mapa en la palma del medio o en el centro del polígono
            if (hasValidPolygon && polygon.coordinates[0].length > 0) {
                // Calcular centro del polígono
                const coords = polygon.coordinates[0];
                const sumLat = coords.reduce((sum, coord) => sum + coord[1], 0);
                const sumLng = coords.reduce((sum, coord) => sum + coord[0], 0);
                const centerLat = sumLat / coords.length;
                const centerLng = sumLng / coords.length;
                setCenterMap([centerLat, centerLng]);
            } else if (lots[0]?.palms.length > 0) {
                const middlePalm = lots[0].palms[Math.floor(lots[0].palms.length / 2)];
                const [lon, lat] = middlePalm.location.coordinates;
                setCenterMap([lat, lon]);
            }
        } catch (error) {
            console.error("Error obteniendo los datos del mapa:", error);
        } finally {
            setLoading(false);
        }
    };

    // Genera colores random bonitos
    const generateLotColors = lots => {
        const colors = {};
        const predefinedColors = [
            '#e91e63', '#9c27b0', '#673ab7', '#3f51b5',
            '#2196f3', '#009688', '#4caf50', '#8bc34a',
            '#ff9800', '#ff5722', '#795548', '#607d8b'
        ];

        lots.forEach((lot, index) => {
            colors[lot.lotName] = predefinedColors[index % predefinedColors.length];
        });
        return colors;
    };

    // Función para manejar clics en las palmas
    const handlePalmClick = (palm, lot) => {
        console.log("Palma clickeada:", palm);
        // Aquí puedes agregar tu lógica para cuando se clickea una palma
        alert(`Palma: ${palm.palmName}\nLote: ${lot.lotName}\nLínea: ${palm.lineName}`);
    };

    useEffect(() => {
        loadLotPositions();
    }, []);

    // ------------------------- MAPA ----------------------------
    useEffect(() => {
        if (!mapData) return;

        const { lots, lotColors } = mapData;

        // Crear mapa
        const map = L.map("map", {
            center: centerMap,
            zoom: 16,
            preferCanvas: true,
        });

        mapRef.current = map;

        // Capa base satelital
        L.tileLayer(
            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
            {
                attribution: "Tiles © Esri — Source: Esri, USDA, USGS, AEX, GeoIQ, and the GIS Community",
            }
        ).addTo(map);

        // IMPORTANTE: Solo agregar el click handler cuando NO estamos capturando
        if (!capturingPoints) {
            map.off('click');
        } else {
            map.on('click', (e) => handleMapClick(e, map));
        }

        // Canvas layer para los marcadores
        const canvasLayer = L.canvasIconLayer({}).addTo(map);
        canvasLayerRef.current = canvasLayer;
        const markerList = [];

        // Dibujar todas las palmas en canvas
        lots.forEach(lot => {
            const color = lotColors[lot.lotName];

            lot.palms.forEach(palm => {
                const lat = palm.location.coordinates[1];
                const lon = palm.location.coordinates[0];
                if (!lat || !lon) return;

                const icon = L.icon({
                    iconUrl: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Ccircle cx='6' cy='6' r='5' fill='${color.replace("#", "%23")}' stroke='%23333' stroke-width='1' /%3E%3C/svg%3E`,
                    iconSize: [12, 12],
                    iconAnchor: [6, 6],
                });

                const marker = L.marker([lat, lon], {
                    icon,
                    interactive: true,
                    bubblingMouseEvents: true
                });

                marker.bindPopup(`
                    <div>
                        <strong>Lote:</strong> ${lot.lotName}<br/>
                        <strong>Línea:</strong> ${palm.lineName}<br/>
                        <strong>Palma:</strong> ${palm.palmName}<br/>
                        <strong>Posición:</strong> ${lat}, ${lon}
                    </div>
                `);

                // Agregar evento de click individual
                marker.on('click', () => handlePalmClick(palm, lot));

                markerList.push(marker);
            });
        });

        // Renderizar todos los markers en canvas
        canvasLayer.addMarkers(markerList);

        // Dibujar el polígono existente si hay (con interactive: false)
        if (existingPolygon && existingPolygon.coordinates && existingPolygon.coordinates[0]) {
            drawExistingPolygon(map, existingPolygon);
        }

        // Limpieza al desmontar
        return () => {
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, [mapData, existingPolygon, capturingPoints]);

    // Reiniciar el evento de click cuando cambia el modo de captura
    useEffect(() => {
        if (!mapRef.current) return;

        const map = mapRef.current;

        // Remover todos los eventos de click
        map.off('click');

        // Si estamos en modo captura, agregar el handler
        if (capturingPoints) {
            map.on('click', (e) => handleMapClick(e, map));
        }
    }, [capturingPoints]);

    // ---------------------- UI ---------------------------
    return (
        <div>
            <Spin spinning={loading}>
                <div className="col-12" style={{ marginTop: "-10px" }}>
                    <Divider
                        orientation="left"
                        style={{
                            borderColor: "#AAAAAA"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >
                            <span>FINCA: {farmName}</span>

                            <Link
                                to="/admin-farms"
                                className="nav-link link-primary p-1"
                            >
                                <i className="bi bi-arrow-left-short fa-lg"></i>

                                <span className="fs-6 m-1">
                                    <strong>
                                        REGRESAR A FINCAS
                                    </strong>
                                </span>
                            </Link>
                        </div>
                    </Divider>

                    <div className="col-12 mb-3">
                        <div className="d-flex gap-2 align-items-center flex-wrap">
                            <button
                                className={`btn ${capturingPoints ? 'btn-danger' : 'btn-primary'}`}
                                onClick={toggleCaptureMode}
                            >
                                {capturingPoints ? 'Cancelar Captura' : 'Capturar Nuevo Polígono'}
                            </button>


                            {capturingPoints && (
                                <>
                                    <span className="badge bg-info">
                                        Puntos: {manualPoints.length} (mínimo 3)
                                    </span>


                                    <button
                                        className="btn btn-secondary"
                                        onClick={finishPolygon}
                                        disabled={manualPoints.length < 3}
                                    >
                                        Generar poligono
                                    </button>



                                    <button
                                        className="btn btn-success"
                                        onClick={saveFarmPolygon}
                                        disabled={manualPoints.length < 3}
                                    >
                                        Guadar poligono Finca
                                    </button>


                                </>
                            )}
                        </div>


                    </div>
                </div>


                <div className="col-12">

                    <div className="row">

                        <div className="col-10">
                            <div id="map" style={{ height: "600px", width: "100%", borderRadius: "8px" }} />
                        </div>

                        <div className="col-2">

                            <textarea className="form-control" style={{ fontSize: '6px' }} rows={28} value={JSON.stringify(manualPoints, null, 2)}>



                            </textarea>


                        </div>

                    </div>

                </div>


            </Spin>
        </div>
    );
};

export default MapFarmPalms;